module.exports = __webpack_public_path__ + "static/media/ua.1c23b8c9.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ua.svg
// module id = 1057
// module chunks = 0